export default [
  { text: 'A - Primary Stroke Center', value: 'A' },
  { text: 'E - Emergency Department Approved for Pediatrics (EDAP)', value: 'E' },
  { text: 'M - Most Accessible Receiving (MAR)', value: 'M' },
  { text: 'N - Perinatal', value: 'N' },
  { text: 'O - Other', value: 'O' },
  { text: 'P - Pediatric Medical Center (PMC)', value: 'P' },
  { text: 'S - STEMI Receiving Center (SRC)', value: 'S' },
  { text: 'T - Trauma Center (TC)/Pediatric Trauma Center (PTC)', value: 'T' },
  { text: 'R - Sexual Assault Response Team (SART) facility', value: 'R' },
  { text: 'K - Comprehensive Stroke Center', value: 'K' },
  { text: 'C - eCPR Center', value: 'C' },
];
